module.exports = __webpack_public_path__ + "static/Unisel6-b622d84b10eccab8e716e1e56bfb01fa.jpg";